export default __webpack_public_path__ + "static/media/campaginOn.e6761beb.svg";